import types from '../types';

const initialState = {
  products: [],
  report: null,
};

const productAnalytics = (
  state = { data: initialState, error: null, loading: false },
  action
) => {
  switch (action.type) {
    case types.PRODUCT_ANALYTICS_OVERVIEW_START:
    case types.PRODUCT_ANALYTICS_REPORT_START:
      return { ...state, loading: true, error: null };

    case types.PRODUCT_ANALYTICS_OVERVIEW_SUCCESS:
      return {
        data: { ...state.data, products: action.payload },
        error: null,
        loading: false,
      };

    case types.PRODUCT_ANALYTICS_REPORT_SUCCESS:
      return {
        data: { ...state.data, report: action.payload },
        error: null,
        loading: false,
      };

    case types.PRODUCT_ANALYTICS_OVERVIEW_ERROR:
    case types.PRODUCT_ANALYTICS_REPORT_ERROR:
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
};

export default productAnalytics;
